import React, { useContext, useState, useMemo } from "react";
import { AlunoContext } from "../../context/AlunoContext";
import AlunoDesativadoCard from "./AlunoDesativadoCard";
import FiltroAlunos from "./FiltroAlunos";
import ModalDetalhesDesativado from "./ModalDetalhesDesativado";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "./AlunosDesativados.css";

const ListaDesativados = () => {
  const { desativados, ativarAluno, eliminarAluno } = useContext(AlunoContext);
  const [alunoSelecionado, setAlunoSelecionado] = useState(null);
  const [loadingId, setLoadingId] = useState(null);
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroClasse, setFiltroClasse] = useState("");
  const navigate = useNavigate();

  const alunosFiltrados = useMemo(() => {
    return desativados.filter((aluno) => {
      const nomeCodigo = (aluno.nome_completo + aluno.codigo_aluno).toLowerCase();
      const filtroNomeLower = filtroNome.toLowerCase();
      const nomeOuCodigoCombina = nomeCodigo.includes(filtroNomeLower);
      const classeCombina = filtroClasse ? aluno.classe === filtroClasse : true;
      return nomeOuCodigoCombina && classeCombina;
    });
  }, [desativados, filtroNome, filtroClasse]);

  const confirmarRestaurar = async (id) => {
    const confirmar = window.confirm("Tem certeza que deseja restaurar este aluno?");
    if (!confirmar || typeof ativarAluno !== "function") return;

    try {
      setLoadingId(id);
      await ativarAluno(id);
      alert("Aluno restaurado com sucesso!");
    } catch (erro) {
      console.error(erro);
      alert("Erro ao restaurar o aluno.");
    } finally {
      setLoadingId(null);
    }
  };

  const confirmarEliminar = async (id) => {
    const confirmar = window.confirm("Tem certeza que deseja eliminar permanentemente este aluno?");
    if (!confirmar || typeof eliminarAluno !== "function") return;

    try {
      setLoadingId(id);
      await eliminarAluno(id);
      alert("Aluno eliminado com sucesso!");
    } catch (erro) {
      console.error(erro);
      alert("Erro ao eliminar o aluno.");
    } finally {
      setLoadingId(null);
    }
  };

  const gerarNomeArquivoBase = () => {
    const dataHoje = new Date().toISOString().slice(0, 10);
    return `ACADE_Alunos_Inativos${dataHoje}`;
  };

  const onExportar = (formato) => {
    if (alunosFiltrados.length === 0) {
      alert("Nenhum aluno para exportar.");
      return;
    }

    const nomeArquivoBase = gerarNomeArquivoBase();

    if (formato === "pdf") {
      const doc = new jsPDF();
  const nomeArquivo = `ACADE_Alunos_Inativos_${new Date().toISOString().slice(0, 10)}.pdf`;

  const img = new Image();
  img.src = logo;

  img.onload = () => {
    const imgWidth = 25; // Largura menor
    const aspectRatio = img.height / img.width;
    const imgHeight = imgWidth * aspectRatio;

    const logoX = 10;
    const logoY = 10;

    doc.addImage(img, "PNG", logoX, logoY, imgWidth, imgHeight);

    // Posição ajustada do título ao lado do logo
    doc.setFontSize(14);
    doc.text("ACADE - Lista de Alunos Inativos no Sistema", logoX + imgWidth + 5, logoY + imgHeight / 2 + 5);

    let y = logoY + imgHeight + 10; // Começar a listar alunos abaixo do logo

    alunosFiltrados.forEach((aluno) => {
      const linha = `${aluno.codigo_aluno}  ${aluno.nome_completo} - ${aluno.classe}`;
      doc.text(linha, 14, y);
      y += 10;
      if (y > 280) {
        doc.addPage();
        y = 20;
      }
    });

    doc.save(nomeArquivo);
      };

      img.onerror = () => {
        alert("Erro ao carregar o logo para exportação PDF.");
      };
    } else if (formato === "excel") {
      const dadosExcel = alunosFiltrados.map(({ codigo_aluno, nome_completo, classe }) => ({
        Código: codigo_aluno,
        Nome: nome_completo,
        Classe: classe,
      }));
      const ws = XLSX.utils.json_to_sheet(dadosExcel);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Alunos");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), nomeArquivoBase + ".xlsx");
    } else if (formato === "csv") {
      const dadosCSV = alunosFiltrados.map(({ codigo_aluno, nome_completo, classe }) =>
        `"${codigo_aluno}","${nome_completo}","${classe}"`
      );
      const csvContent = "Código,Nome,Classe\n" + dadosCSV.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, nomeArquivoBase + ".csv");
    } else {
      alert("Formato de exportação não suportado.");
    }
  };

  return (
    <div className="lista-alunos">
      <h2>Alunos Inativos</h2>

      <button onClick={() => navigate("/dashboard")} className="btn-voltar">
        ← Voltar para Alunos Ativos
      </button>

      <FiltroAlunos
        filtroNome={filtroNome}
        setFiltroNome={setFiltroNome}
        filtroClasse={filtroClasse}
        setFiltroClasse={setFiltroClasse}
        onExportar={onExportar}
      />

      <div className="lista-container">
        {alunosFiltrados.length > 0 ? (
          alunosFiltrados.map((aluno) => (
            <AlunoDesativadoCard
              key={aluno.id}
              aluno={aluno}
              onVisualizar={() => setAlunoSelecionado(aluno)}
              onRestaurar={() => confirmarRestaurar(aluno.id)}
              onEliminar={() => confirmarEliminar(aluno.id)}
              disabled={loadingId === aluno.id}
            />
          ))
        ) : (
          <p className="mensagem-vazio">Nenhum aluno desativado.</p>
        )}
      </div>

      {alunoSelecionado && (
        <ModalDetalhesDesativado
          aluno={alunoSelecionado}
          onClose={() => setAlunoSelecionado(null)}
          onRestaurar={() => confirmarRestaurar(alunoSelecionado.id)}
          onEliminar={() => confirmarEliminar(alunoSelecionado.id)}
          disabled={loadingId === alunoSelecionado.id}
        />
      )}
    </div>
  );
};

export default ListaDesativados;
